import { CheckoutConfig, Session } from '../../types/checkout';
import { SalesLocation } from '../../types/customers';
import { SessionResponse } from './types';
import { Account } from '../../types/management-auth';

export enum ActionTypes {
    FetchTerminalData = '[virtual-terminal-v2] FETCH_TERMINAL_DATA',
    FetchTerminalDataResponse = '[virtual-terminal-v2] FETCH_CHECKOUT_CONFIG_RESPONSE',
    CreateCheckoutSession = '[virtual-terminal-v2] CREATE_CHECKOUT_SESSION',
    CreateCheckoutSessionResponse = '[virtual-terminal-v2] CREATE_CHECKOUT_SESSION_RESPONSE',
    ClearData = '[virtual-terminal-v2] CLEAR_DATA',
}

export interface FetchTerminalData {
    type: ActionTypes.FetchTerminalData;
    payload: {
        accountId: string;
        fetchLocations: boolean;
    };
}

export interface FetchTerminalDataResponse {
    type: ActionTypes.FetchTerminalDataResponse;
    payload: {
        config: CheckoutConfig;
        locations: SalesLocation[];
        account?: Account;
    };
    meta: {
        cause: FetchTerminalData;
    };
}

export const fetchCheckoutConfig = (accountId: string, fetchLocations: boolean): FetchTerminalData => {
    return {
        type: ActionTypes.FetchTerminalData,
        payload: {
            accountId,
            fetchLocations,
        },
    };
};

export interface CreateCheckoutSession {
    type: ActionTypes.CreateCheckoutSession;
    payload: {
        accountId: string;
        session: Session;
        email?: boolean;
    };
}

export interface CreateCheckoutSessionResponse {
    type: ActionTypes.CreateCheckoutSessionResponse;
    payload: {
        sessionResponse: SessionResponse;
    };
    meta: {
        cause: CreateCheckoutSession;
    };
}

export function createCheckoutSession(accountId: string, session: Session, email?: boolean): CreateCheckoutSession {
    return {
        type: ActionTypes.CreateCheckoutSession,
        payload: {
            accountId,
            session,
            email,
        },
    };
}

export interface ClearData {
    type: ActionTypes.ClearData;
}

export function clearData(): ClearData {
    return {
        type: ActionTypes.ClearData,
    };
}

export type Actions =
    | CreateCheckoutSession
    | CreateCheckoutSessionResponse
    | FetchTerminalData
    | FetchTerminalDataResponse
    | ClearData;
